import React from 'react'
import Dropzone from 'react-dropzone'
import nesProp from 'nested-property'
import uuidv4 from 'uuid/v4'
import moment from 'moment'
import cs from 'classnames'
import styles from './ClaimWizard.scss'
import WizardModalContent from './shared/WizardModalContent'
import i18n from 'lib/i18n'
import { CreatableSelectWrapper } from "./shared/WizardSelects/WizardReactSelect"
import MifidButton from '../DSDocuments/mifidButton'
import WizardButtons from './shared/WizardButtons/WizardButtons'
import c from 'state/constants'
import DsListButtonsWrapper from '../DSDocuments/dsListButtonsWrapper'
import EmailButton from '../emailSender/emailButton'
import { shouldEditThePackage, stakeholdersCanSign, stakeholdersNeedInvitation } from '../DSDocuments/documentsHelpers'

// variables out of module
const _ = i18n('claimWizard')
const ClaimWizardStepThree = (props) => {
    const { claimWizardDocumentsData, claimDocumentsOptions, setAlternativeMethod, onAddOptionalDocument, onRemoveOptionalDocument,
        onChangeOptionalDoctypeId, claimData, clientData, contractDetails, docsFromDocumentation, isDragging, setFileDrag,
        addFilesToClaimWizardState, documentFiles, removeDocumentFile, updateDsPackageList, dsPackages, canCreateMifid, directSignMethod,
        recreatePackageMethod, sendRemindersMethod, getDsStakeholdersForInvitation, afterInvUpdates,
    } = props
    const temporaryFiles = {}
    const getDocumentLabel = (docType) => {
        const index = claimDocumentsOptions.findIndex(oneOption => oneOption.value === docType)
        if (index === -1) {
            return docType
        }
        return claimDocumentsOptions[index].label
    }

    const getAlternativeOptions = (doc) => {
        const alternativeDocOptions = [
            {
                label: _('mainDocOption'),
                value: doc.docType
            }
        ]
        if (doc.alternativeDocTypes) {
            doc.alternativeDocTypes.forEach(option => {
                alternativeDocOptions.push({
                    label: _('alternativeDocOption') + ' ' + option.alternativeLabel,
                    value: option.alternativeId
                })
            })
        }
        return alternativeDocOptions
    }

    const getOptionalDocumentOptions = (documents, currentDocType) => {

        const result = []
        docsFromDocumentation.forEach(oneDocument => {
            if (oneDocument.required === "Optional") {
                if ((oneDocument.docType === currentDocType) || !documents.some(doc => doc.docType === oneDocument.docType)) {
                    result.push({
                        label: getDocumentLabel(oneDocument.docType),
                        value: oneDocument.docType
                    })
                }
            }
        })
        result.sort((a, b) => a.label.localeCompare(b.label))

        return result
    }

    const collectModuleOptions = () => {
        let clientId = claimData.clientId

        const contractId = nesProp.get(claimData, "contractId")


        const contractDocuments = nesProp.get(contractDetails, "documents")
        const contractDocumentsId = contractId

        let emails = nesProp.get(clientData, clientId + '.detail.emails')
        let clientName = nesProp.get(claimData, "clientName")

        if (emails && emails.length) {
            emails = emails.map((item) => ({
                referenceId: clientId,
                label: clientName,
                value: item.email,
                default: (item.default == "true" || item.default == true) ? true : false
            }))

            emails = emails.sort((item, item2) => {
                if (item.default && !item2.default) { return -1 }
                if (!item.default && item2.default) { return 1 }
                if ((item.default && item2.default) || (!item.default && !item2.default)) { return 0 }
            }) || []
        }
        return {
            contractNumber: contractDetails ? contractDetails.contractNumber : claimData.contractNumber,
            claimsNumber: claimData.claimNumber,
            clientName: clientName,
            clientEmails: emails,

            clientDocuments: nesProp.get(clientData, clientId + ".clientDocuments"),
            clientDocumentsType: 'client',
            clientDocumentsId: clientId,

            // new v6 mode
            claimDocuments: claimData.documents || [],
            claimDocumentsType: "claim",
            claimDocumentsId: claimData.claimId,
            companyCancelMail: nesProp.get(contractDetails, 'companyCancelMail'),

            contractDocuments: contractDocuments || [],
            contractDocumentsType: "contract",
            contractDocumentsId: contractDocumentsId,

            clientId: false,
            contractId: false,
            claimId: claimData.claimId,
            company: nesProp.get(contractDetails, 'insuranceCompany'),

            brokerNumber: nesProp.get(clientData, "brokerNumber"),
            claim: claimData,
            // claimDetail,
            clientNumber: nesProp.get(clientData, ".main.clientNumber"),
            clientData,
        }
    }

    /**
     * Will create a new file object and add it to the temporaryFiles object
     * Will set a list of files to store in the state
     * Will end drag event
     * @param {*} docType
     * @param {*} ev 
     */
    const addFiles = (ev, docType, alternativeId, mainDocType) => {
        const files = ev
        const tempStoreFiles = []
        for (const file of files) {
            const fileId = uuidv4()
            const oneTemp = {
                name: file.name,
                lastModified: moment(),
                size: file.size,
                type: file.type.split('/').splice(-1)[0],
                progress: 0,
                fileId,
                docType,
                uploaded: false,
                error: '',
                alternativeId,
                mainDocType,
                file: file
            }
            if (oneTemp.size > 10 * 1024 * 1024) {
                oneTemp.error = _('too_large_file')
            }
            if (oneTemp.size === 0) {
                oneTemp.error = _('file_is_empty_maybe_compressed')
            }
            //error is wrong file type
            if (/^(jpe?g|gif|png|pdf|tiff?)$/.test(oneTemp.type) ||
                (/^(|(x-)?download)$/.test(oneTemp.type) && /\.(jpe?g|gif|png|pdf|tiff?)$/.test(oneTemp.name))) {
                tempStoreFiles.push(oneTemp)
                temporaryFiles[fileId] = file
            } else {
                oneTemp.error = _('wrong_file_type')
                tempStoreFiles.push(oneTemp)
            }
        }
        addFilesToClaimWizardState(tempStoreFiles)
        setFileDrag(false)
    }

    const removeOptionalDocumentAndFiles = (doc) => {
        const filesToRemove = documentFiles.filter(file => file.docType === doc.docType)
        for (const file of filesToRemove) {
            removeDocumentFile(file.fileId)
        }
        onRemoveOptionalDocument(doc.id)
    }

    /**
    * This function helps to use an icon on a safe way
    */
    const getIcon = iconName => {
        try {
            return require(`resources/images/${iconName}`)
        } catch (err) {
            return require(`resources/images/icn-no-result.svg`)
        }
    }

    /**
    * Checks if package has stakeholders that haven't signed yet
    * @param {*} dsPackage
    * @returns Boolean
    */
    const checkForUnfinishedStakeholder = (dsPackage) => {
        let hasUnfinishedStakeholder = false
        dsPackage.dsStakeholders.map(oneStakeholder => {
            if (!oneStakeholder.finished && oneStakeholder.signerType !== "BROKER") {
                hasUnfinishedStakeholder = true
            }
        })
        return hasUnfinishedStakeholder
    }


    // ================================
    // #region Render
    // ================================

    const renderListOfDocuments = (document) => {
        return (
            <div className={styles.documentListContainer} >
                {documentFiles.filter(file => file.docType === document.docType)
                    .sort((a, b) => a.name.localeCompare(b.name)).map((file, key) => {
                        return (
                            <div key={key} className={styles.documentListItem}>
                                <div className={styles.documentName}>{file.name}</div>
                                <div className={styles.documentStatus}>
                                    <label className={cs(styles.formLabel, styles.statusLabel)}>{_('documentStatus')}:</label>
                                    <div className={cs(styles.documentStatusValue, file.error ? styles.error : '')}>
                                        {file.dsPackageStatus ? (file.dsPackageStatus !== 'finished' ? _(file.dsPackageStatus) : file.uploaded ? _('uploaded') : _('dsDocumentNotUploaded'))
                                            : file.uploaded ? _('uploaded') : file.error ? file.error : _('readyToUpload')}
                                    </div>
                                </div>
                                {renderDSButtons(file, key)}
                            </div>
                        )
                    })
                }
            </div>
        )
    }

    const renderDSButtons = (file, key) => {
        const dsPackage = dsPackages[file.dsPackageId]
        let isEditableThePackage = shouldEditThePackage(
            nesProp.get(dsPackage, "statusHistory"),
            nesProp.get(dsPackage, "isEditable")
        )

        let blocked = false
        const statusBlackList = ['packageStatusExpired', 'packageStatusRejected', 'packageStatusRevoked', 'packageStatusFailed',
            'packageStatusFinished', 'documentsDownloaded', 'documentsTransferredToOracle', 'documentError',
            'packageStatusDeleted', 'packageStatusDraft', 'emailSentWithSignedDocs', 'generalError', 'printed'
        ]
        if (dsPackage && dsPackage.statusHistory) {
            dsPackage.statusHistory.forEach((oneStatus) => {
                if (statusBlackList.includes(oneStatus.status)) {
                    blocked = true
                }
            })
        }

        let packageStatusError = dsPackage && dsPackage.status === c.DS_DOCUMENTS_GENERAL_ERROR || blocked

        return (
            <div className={styles.documentActionButtons}>
                <div className={styles.removeDocumentBtnWrapper}>
                    <button
                        type="button"
                        className={cs(styles.removeDocumentBtn,
                            file.uploaded || file.dsPackageStatus ? styles.invisible : ''
                        )}
                        onClick={(e) => {
                            e.preventDefault()
                            removeDocumentFile(file.fileId)
                        }}
                    >
                        X
                    </button>
                    <span className={cs([styles.tooltip, styles.removeDocumentBtnTooltip])}>{_('removeDocumentBtnTooltip')}</span>
                </div>
                {canCreateMifid && dsPackage &&
                    <div className={cs(styles.mifidWrapper)}>
                        <MifidButton
                            step={c.DSWIZARD_STEP_1_COMPOSE_PACKAGE}
                            packageId={nesProp.get(dsPackage, "_id")}
                            lang={lang}
                            callBackOnClose={() => { }}
                            callBackOnCloseClaimWizard={(packageId) => {
                                if (packageId) {
                                    updateDsPackageList(packageId)
                                }
                            }}
                            moduleKeyToSet={nesProp.get(dsPackage, "uploadedOnModule")}
                            mifidKey={key + nesProp.get(dsPackage, "_id")}
                            clientId={nesProp.get(dsPackage, "clientId")}
                            claimId={nesProp.get(dsPackage, "claimId")}
                            claimNumber={nesProp.get(dsPackage, "claimNumber")}
                            contractId={nesProp.get(dsPackage, "contractId")}
                            contractNumber={nesProp.get(dsPackage, "contractNumber")}
                            tarificationId={nesProp.get(dsPackage, "tarificationId")}
                            tarificationNumber={nesProp.get(dsPackage, "tarificationNumber")}
                            stakeholders={nesProp.get(dsPackage, "dsStakeholders")}
                            claimWizardDocType={nesProp.get(dsPackage, "claimWizardDocType")}
                            alienUserId={dsPackage.userId}
                            hideButton={!isEditableThePackage}
                            isResume={true}
                            moduleOptions={collectModuleOptions()}
                            onlyIcon={true}
                        />
                        <span className={cs([styles.tooltip, styles.mifidTooltip])}>{_('mifidTooltip')}</span>
                    </div>
                }
                {/* reminder btn */}
                {dsPackage && !packageStatusError &&
                    dsPackage.mustBeSigned && !dsPackage.hasFinishStatus
                    && checkForUnfinishedStakeholder(dsPackage)
                    && !shouldEditThePackage(dsPackage.statusHistory, dsPackage.isEditable)
                    && !stakeholdersNeedInvitation(dsPackage)
                    && (
                        <div className={cs(styles.marginBot, styles.grow, styles.reminderButtonWrapper)}>
                            <button className={cs(styles.greenButton, styles.greenButtonDsList, "enabled", styles.grow)}
                                onClick={(ev) => {
                                    ev.stopPropagation()
                                    return sendRemindersMethod(dsPackage.id)
                                }
                                }>
                                <img className={cs(styles.icon)} src={getIcon('icn-inbox-blue.svg', true)} />
                            </button>
                            <span className={cs([styles.tooltip, styles.reminderTooltip])}>{_('reminderTooltip')}</span>
                        </div>
                    )
                }

                {/* //invitation button */}
                {dsPackage && !packageStatusError && dsPackage.mustBeSigned && !dsPackage.hasFinishStatus &&
                    stakeholdersNeedInvitation(dsPackage) &&
                    !shouldEditThePackage(dsPackage.statusHistory, dsPackage.isEditable) &&
                    <div className={styles.inviteToSignWrapper}>
                        <EmailButton
                            noLabel={true}
                            isWhiteIcon={true}
                            modalId={"emailSenderModal" + dsPackage.id}
                            hideCC={true}
                            multiLanguage={true}
                            serialSending={true}
                            isCreatable={false}
                            forceIsMulti={true}
                            key={"customizeInvitationRenderEmailSenderButtonFromEmailChangerKey"}
                            onInit={() => {
                            }}
                            onSentLate={async response => {
                                await afterInvUpdates(response, dsPackage, dsPackage.dsStakeholders)
                            }}
                            moduleKeyToSet={"clientsClaimsDetail"}
                            moduleOptions={{
                                ...collectModuleOptions(),
                                dsPackage: dsPackage,
                                brokerNumber: nesProp.get(dsPackage, "brokerNumber"),
                                brokerEmailAddress: nesProp.get(dsPackage, "brokerEmailAddress"),
                                autoSelectTemplate: true,
                                usePlaceholdersForClientVariables: true,
                                stakeholders: dsPackage.dsStakeholders.filter((oneStake) => (oneStake.signerType !== "BROKER")),
                                clientEmails: dsPackage.dsStakeholders
                                    .filter((oneStake) => (oneStake.signerType !== "BROKER"))
                                    .map((oneHolder) => ({
                                        referenceId: oneHolder._id,
                                        value: oneHolder.email,
                                        lang: oneHolder.language,
                                        isPermanentSelected: true,
                                        isCC: false,
                                        label: oneHolder.firstName + " " + oneHolder.lastName
                                    })
                                    )
                            }}
                            getDSStakeholders={async (stakeholderIdArray) => (await getDsStakeholdersForInvitation(stakeholderIdArray))}
                            customClassName={cs(styles.greenButton, styles.enabled)}
                        />
                        <span className={cs([styles.tooltip, styles.inviteToSignTooltip])}>{_('inviteToSignTooltip')}</span>
                    </div>
                }

                {/* //direct sign button */}
                {
                    dsPackage && !packageStatusError && !isEditableThePackage && dsPackage.mustBeSigned && stakeholdersCanSign(dsPackage) &&
                    <div className={cs(styles.marginBot, styles.grow, styles.directSignButtonWrapper)}>
                        <button className={cs(styles.greenButton, styles.noPadding,
                            styles.directSignButton)}
                            onClick={(ev) => {
                                ev.stopPropagation()
                                return directSignMethod(dsPackage.id)
                            }
                            }>
                            <img className={cs(styles.icon)} src={getIcon('a-edit_1x_blue.svg', true)} />
                            <span className={cs([styles.tooltip, styles.directSignTooltip])}>{_('directSignTooltip')}</span>
                        </button>
                    </div>
                }
                {
                    dsPackage && !isEditableThePackage && !dsPackage.hasFinishStatus && dsPackage.mustBeSigned &&
                    // {dsPackage &&
                    <div className={cs(styles.recreatePackageWrapper)}>
                        <button className={cs(
                            styles.greenButton, styles.noPadding,
                            // styles.greenButtonDsList,
                            "enabled",
                            styles.buttonCustomizationRenew
                        )}
                            onClick={async (ev) => {
                                ev.stopPropagation()
                                await recreatePackageMethod(dsPackage)
                            }}
                        >
                            <img className={cs(styles.icon)} src={getIcon('autorenew.svg')} />
                            <span className={cs([styles.tooltip, styles.recreateTooltip])}>{_('recreateTooltip')}</span>
                        </button>
                    </div>
                }
            </div >
        )
    }

    const renderDocumentButtons = (document, key, alternativeId = '', mainDocType = '') => {
        return (
            <div className={styles.buttonsWrapper}>
                {document.docType &&
                    <Dropzone
                        style={{ minHeight: 50 }}
                        className={styles.dropzone + " " + ((isDragging && isDragging === document.docType) && styles.drag)}
                        onDragEnter={() => setFileDrag(document.docType)}
                        onDragLeave={() => setFileDrag('')}
                        onDrop={(ev) => addFiles(ev, document.docType, alternativeId, mainDocType)}
                    >
                        <div className={styles.dropzonePlaceholder}>{_('filePlaceholder')}</div>
                    </Dropzone>}
                {document && document.hasDsDocumentTemplate && canCreateMifid &&
                    <div className={cs(styles.mifidButton)}>

                        <MifidButton
                            moduleKeyToSet={c.DS_MODULE_CLAIM_WIZARD}
                            subModuleKeyToSet={c.DS_MODULE_CLAIM_WIZARD}
                            clientId={claimData.clientId}
                            claimId={claimData.claimId}
                            claimNumber={claimData.claimNumber}
                            callBackOnClose={() => { }}
                            callBackOnCloseClaimWizard={(packageId) => {
                                if (packageId) {
                                    updateDsPackageList(packageId)
                                }
                            }}
                            moduleOptions={collectModuleOptions()}
                            claimWizardDocType={document.docType}
                            mifidKey={key + document.docType}
                        />
                    </div>
                }
            </div>
        )
    }


    const renderAlternativesList = (document) => {
        const index = document.alternativeDocTypes.findIndex(oneAlternative => oneAlternative.alternativeId === document.alternativeSelectionId)
        return document.alternativeDocTypes[index].alternatives.map((oneAlternative, key) => {
            return (
                <div key={key} className={styles.sectionWrapper}>
                    <div className={styles.formInputContainer} >
                        <label className={styles.formLabel}>{getDocumentLabel(oneAlternative.docType)}</label>
                    </div>
                    <div className={styles.documentHandlerSection} >
                        <div className={cs(styles.formLabel, styles.marginLeftS, styles.short1)}></div>
                        {renderDocumentButtons(oneAlternative, key, document.alternativeDocTypes[index].alternativeId, document.docType)}
                        {/* <div className={styles.documentListContainer} > */}
                        {renderListOfDocuments(oneAlternative)}
                        {/* </div> */}
                    </div>
                </div>
            )
        })
    }

    const renderDocuments = (documents, isOptional = false) => {
        return documents.map((document, key) => {
            return (
                <div key={key} className={styles.sectionWrapper}>
                    {isOptional &&
                        <div className={styles.formInputContainer} >
                            <div className={cs(styles.documentHandlerSection, styles.noPadding)}>
                                < div className={styles.docTypeControlWrapper}>
                                    <div className={cs(styles.docTypeSelector)}>
                                        <CreatableSelectWrapper
                                            type="text"
                                            value={document.docType}
                                            options={getOptionalDocumentOptions(documents, document.docType)}
                                            onChange={(value) => onChangeOptionalDoctypeId(value ? value.value : '', document.id)}
                                            formatCreateLabel={_('optionalDocType')}
                                            name="optionalDocType"
                                            isClearable
                                            isDisabled={documentFiles.some(docFile => docFile.docType === document.docType)} //disable when there are documents attached
                                            isCreatableSelect={false}
                                        />
                                    </div>

                                    <div className={cs(styles.docRemoveWrapper)}>

                                        <button
                                            type="button" //disable when there documents attached
                                            className={cs(styles.removeDocumentBtn)}
                                            onClick={(e) => {
                                                e.preventDefault()
                                                removeOptionalDocumentAndFiles(document)
                                            }}
                                            disabled={documentFiles.some(docFile => (docFile.docType === document.docType && docFile.uploaded) ||
                                                (docFile.docType === document.docType && docFile.dsPackageStatus))} //disable when there are documents attached
                                        >
                                            {_('removeOptionalDocument')}
                                        </button>

                                    </div>

                                </div>
                            </div>
                        </div>
                    }
                    {!isOptional &&
                        <div className={styles.formInputContainer} >
                            <label className={styles.formLabel}>{getDocumentLabel(document.docType)}</label>

                            <div className={cs(styles.formLabel, styles.marginLeftS, styles.short1)}></div>

                            {document.alternativeDocTypes && document.alternativeDocTypes.length > 0 &&
                                <div className={cs(styles.formInput, styles.formInputCreatableSelect,
                                    styles.sizeM, styles.last, styles.fixeMaxWidth, styles.marginRightS)}>
                                    <CreatableSelectWrapper
                                        type="text"
                                        value={document.alternativeSelectionId || document.docType}
                                        options={getAlternativeOptions(document)}
                                        onChange={(value) => setAlternativeMethod(value.value, document.docType)}
                                        formatCreateLabel={_('alternativeDocs')}
                                        name="alternativeDocs"
                                        isDisabled={
                                            documentFiles.some(oneDocFile => oneDocFile.docType === document.docType
                                                || oneDocFile.alternativeId && document.alternativeDocTypes
                                                && document.alternativeDocTypes.some(alternative => alternative.alternativeId === oneDocFile.alternativeId))
                                        }
                                        isClearable
                                        isCreatableSelect={false}
                                    />
                                </div>
                            }
                        </div>
                    }
                    {document.alternativeDocTypes && document.alternativeDocTypes.length > 0 && document.alternativeSelectionId &&
                        document.alternativeSelectionId !== document.docType ?
                        renderAlternativesList(document)
                        :
                        <div key={key} className={styles.sectionWrapper}>

                            <div className={styles.documentHandlerSection} >
                                <div className={cs(styles.formLabel, styles.marginLeftS, styles.short1)}></div>
                                {renderDocumentButtons(document, key)}
                                {/* <div className={styles.documentListContainer} > */}
                                {renderListOfDocuments(document)}
                                {/* </div> */}
                            </div>
                        </div>
                    }

                </div>
            )
        })
    }

    return (
        <WizardModalContent modalTitle={_('stepThreeTitle')}>

            <form method="post" onSubmit={(ev) => ev.preventDefault()} className={styles.modalFormContent} key={"claimWizardStepThreeForm"}>
                <div className={styles.formInputContainer} >
                    <div className={styles.titleLabel} dangerouslySetInnerHTML={{ __html: _('stepThreeSubTitle') }} />
                </div>
                <div className={styles.sectionWrapper}>
                    <div className={styles.formInputContainer} >
                        <label className={cs(styles.titleLabel, styles.docSectionTitle)}>{_('wizardMandatory')}</label>
                    </div>
                </div>
                {claimWizardDocumentsData.wizardMandatory && claimWizardDocumentsData.wizardMandatory.length > 0 &&
                    renderDocuments(claimWizardDocumentsData.wizardMandatory)
                }

                {claimWizardDocumentsData.claimMandatory && claimWizardDocumentsData.claimMandatory.length > 0 &&
                    <div className={styles.formSeparator}></div>
                }
                {claimWizardDocumentsData.claimMandatory && claimWizardDocumentsData.claimMandatory.length > 0 &&
                    <div className={styles.sectionWrapper}>
                        <div className={styles.formInputContainer} >
                            <label className={cs(styles.titleLabel, styles.docSectionTitle)}>{_('claimMandatory')}</label>
                        </div>
                    </div>
                }
                {claimWizardDocumentsData.claimMandatory &&
                    renderDocuments(claimWizardDocumentsData.claimMandatory)
                }
                <div className={styles.formSeparator}></div>

                <div className={styles.sectionWrapper}>
                    <div className={styles.formInputContainer} >
                        <label className={cs(styles.titleLabel, styles.docSectionTitle)}>{_('wizardOptional')}</label>
                    </div>
                </div>
                {claimWizardDocumentsData.wizardOptional &&
                    renderDocuments(claimWizardDocumentsData.wizardOptional, true)
                }
                <WizardButtons
                    nextBtn={{
                        method: () => {
                            onAddOptionalDocument()
                        },
                        disabled: (getOptionalDocumentOptions(claimWizardDocumentsData.wizardOptional, true).length === 0) ||
                            (claimWizardDocumentsData.wizardOptional.some((document) => !document.docType)),
                        label: '+'
                    }}
                />
                {props.children}
            </form>
        </WizardModalContent >
    )

    // #endregion

}

export default ClaimWizardStepThree


// WEBPACK FOOTER //
// ./components/ClaimsWizard/ClaimWizardStepThree.js